import type { ActionContext, ActionTree } from 'vuex';
import type { IExamRoomState } from '@/store/modules/examroom/types';
import type { RootState } from '@/store/types';
import { ApiCaller } from '@/ApiCaller';

type ExamRoomActionContext = ActionContext<IExamRoomState, RootState>;
type ExamRoomActionTree = ActionTree<IExamRoomState, RootState>;

export const actions: ExamRoomActionTree = {
  async fetchExamRoom(context: ExamRoomActionContext): Promise<any> {
    const assessments = await ApiCaller.getInstance().get(`${context.rootState.productPrefix}examroom`);

    context.commit('setAssessments', assessments.data);
  },

  async downloadTestPDF(
    context: ExamRoomActionContext,
    payload: {
      s3Key: string;
    }
  ): Promise<string> {
    const { s3Key } = payload;

    try {
      const response = await ApiCaller.getInstance().post<
        { [key: string]: string },
        { names: string[]; bucket: string }
      >(`${context.rootState.productPrefix}content/urls`, {
        names: [s3Key],
        bucket: import.meta.env.VITE_APP_S3_PRIVATE_BUCKET || 'eprep-private',
      });

      const url = response.data[s3Key];

      if (!url) {
        throw new Error('Failed to get download URL from server');
      }

      return url;
    } catch (error) {
      console.error('Error on generate download URL', error);
      throw error;
    }
  },
};
